import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IHello } from '../hello.model';

@Injectable({
  providedIn: 'root'
})

export class ImpersonateRepository {

  constructor(private http: HttpClient) { }


  public helloUser():Observable<IHello> {
    return this.http.get<IHello>(`${environment.apiUrl}/hello-user`);
  }

  public switchUser(username:string):Observable<IHello> {
    return this.http.post<IHello>(`${environment.apiUrl}/switch-user?username=${username}`, null);
  }

  public exitUser():Observable<IHello> {
    return this.http.post<IHello>(`${environment.apiUrl}/exit-user`, null);
  }

}